import {
  Directive,
  OnDestroy,
  Input,
  HostListener,
  ElementRef
} from '@angular/core';
import { TooltipService } from './tooltip.service';

@Directive({
  selector: '[appCustomTooltip]'
})

export class TooltipDirective implements OnDestroy {
  @Input() tooltipTitle: string = '';
  @Input() destroyOnClick: boolean;
  @Input() position: string;
  // @Input() delay: string | number;
  private id: number;
  private canShow: boolean = true;
  private elementWasClicked: boolean = false;
  // private delayTime: number = 0;

  constructor(
    private tooltipService: TooltipService,
    private element: ElementRef
  ) { }

  // ngOnInit(): void {
  //   if (typeof this.delay === 'string') {
  //     if (this.delay === 'slow')
  //       this.delayTime = 3000;
  //       else if (this.delay === 'medium')
  //       this.delayTime = 2000;
  //       else if (this.delay === 'fast')
  //       this.delayTime = 1000;
  //   } else if (typeof this.delay === 'number')
  //     this.delayTime = this.delay;
  // }

  @HostListener('mouseenter', ['$event'])
  onMouseEnter($event: MouseEvent): void {
    if (this.destroyOnClick && this.elementWasClicked) {
      this.canShow = false;
    }

    if (this.canShow) {
      // setTimeout(
      //   () => {
      //     this.setTooltipPosition($event);
      //     this.id = Math.random();
      //     this.tooltipService.components.push({
      //       id: this.id,
      //       position: this.position,
      //       title: this.tooltipTitle
      //     });
      //   },
      //   this.delayTime
      // );
      this.setTooltipPosition($event);
      this.id = Math.random();
      this.tooltipService.components.push({
        id: this.id,
        position: this.position,
        title: this.tooltipTitle
      });
    }
  }

  private setTooltipPosition($event: MouseEvent): void {
    const viewportOffset = this.element.nativeElement.getBoundingClientRect();

    if (this.position === 'top') {
      this.tooltipService.setTooltipPosition({
        x: viewportOffset.left + this.element.nativeElement.offsetWidth / 2,
        y: viewportOffset.top - 10
      });
    } else if (this.position === 'left') {
      this.tooltipService.setTooltipPosition({
        x: viewportOffset.left - 10,
        y: viewportOffset.top + this.element.nativeElement.offsetHeight / 2
      });
    } else if (this.position === 'right') {
      this.tooltipService.setTooltipPosition({
        x: viewportOffset.left + this.element.nativeElement.offsetWidth + 10,
        y: viewportOffset.top + this.element.nativeElement.offsetHeight / 2
      });
    } else if (this.position === 'bottom') {
      this.tooltipService.setTooltipPosition({
        x: viewportOffset.left + this.element.nativeElement.offsetWidth / 2,
        y: viewportOffset.top + this.element.nativeElement.offsetHeight + 10
      });
    } else {
      this.tooltipService.updateTooltipPosition($event.clientX, $event.clientY);
    }
  }

  @HostListener('click')
  onClick(): void {
    this.elementWasClicked = true;

    if (this.destroyOnClick) {
      this.destroy();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.destroy();
  }

  @HostListener('mousemove', ['$event'])
  onMousemove($event: MouseEvent): void {
    if (this.position === 'followCursor') {
      this.tooltipService.updateTooltipPosition($event.clientX, $event.clientY);
    }
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  destroy(): void {
    const currentTooltipIndex = this.tooltipService.components.findIndex(
      (tooltip) => {
        return tooltip.id === this.id;
      }
    );

    this.tooltipService.components.splice(currentTooltipIndex, 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/tooltips/tooltip.directive.ts